import { TextInput } from 'jl-design-system/components/text-input/TextInput';
import { asciiExtendedOnly } from '../../../utils/normalizers';
import getRegExp, { asciiExtendedPattern } from '../../../utils/regex';

export const PRODUCT_INFORMATION = {
  component: TextInput,
  name: 'information',
  labelText: 'Please give further details if you have a specific product in mind',
  id: 'information',
  type: 'text',
  required: true,
  maxLength: 150,
  regex: getRegExp(asciiExtendedPattern),
  validationMessageKeys: {
    required: 'Please enter your selected product',
  },
  normalize: asciiExtendedOnly,
  //change back to 'instruction' if needed
  description: 'Please include the brand, range and colour if possible',
};
